import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { MuiOtpInput } from "mui-one-time-password-input";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../API/config";
import { axiosPrivate } from "../../axios/axios";
import { commonCss } from "../../StyleConfig/CommonCss";
import ErrorProps from "../../Component/Errorprops";
import AuthShell, { authButtonSx } from "./AuthShell";

const OTPComp = () => {
  const code = useSelector((state) => state.auth.getEmailAndOTP);
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();

  const initialValues = { otp: "" };
  const onSubmit = (value) => {
    setLoading(true);
    // let decoded = base64_decode(code.code);
    // if (value.otp === decoded) {
    const postData = { emailId: code.emailId, otp: value.otp };
    const getLink = api.account.verifyOTP;
    axiosPrivate
      .post(`${getLink}`, postData)
      .then((res) => {
        console.log(res);
        navigate("/setpassword");
        setLoading(false);
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        console.log(e);
        setLoading(false);
      });

    // toast.success("Success")

    // } else {
    //   toast.error("Invaild Code")
    //   setLoading(false)
    // }
  };

  const validationSchema = Yup.object({
    otp: Yup.string()
      .required("Please Fill The OTP")
      .min(6, "Complete the box")
      .max(6, "Complete the box"),
  });

  return (
    <AuthShell
      title="Verify OTP"
      subtitle="Enter the 6-digit code sent to your email."
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form style={{ width: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Box>
                <MuiOtpInput
                  length={6}
                  value={values.otp}
                  onChange={(e) => {
                    setFieldValue("otp", e);
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                />
                <ErrorMessage name="otp">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage>
              </Box>
              <Button
                type="submit"
                variant="contained"
                disabled={isLoading}
                fullWidth
                sx={authButtonSx(isLoading)}
              >
                {isLoading ? "Loading..." : "Verify"}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </AuthShell>
  );
};

export default OTPComp;




